import $ from 'jquery';

$(document).on('turbo:load', () => {
  const $ctaEmail = $('.cta-email');

  if ( $ctaEmail.length ) {
    $ctaEmail.on('submit', '.cta-email--form', (event) => {
      const $currentForm = $(event.target);
      const formUrl = $currentForm.attr('action').trim();
      const emailValue = $currentForm.find('input[name="email"]').val().trim();
      const formIdValue = $currentForm.find('input[name="formId"]').val().trim();

      if (formUrl.length && emailValue.length && formIdValue.length) {
        $.ajax({
          url: formUrl,
          method: 'post',
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          },
          data: {
            mauticform: {
              email: emailValue,
              formId: formIdValue
            }
          },
          success: (response) => {
            if (response.success) {
              $currentForm.parent().addClass('cta-email--form-sent');
            }
          }
        });
      }

      event.preventDefault();
    });
  }
});
